import { useRef, ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';
import { FileDropItem, useDrop } from 'react-aria';
import { setImageBase64 } from '@store/order/slice';
import plusIconDark from '@assets/icons/menu-plus-icon-dark.svg';



export const ImageInput = () => {

	const dispatch = useDispatch();
	const updateImageBase64 = (value: string | null) => dispatch(setImageBase64(value));

	const ref = useRef(null);
	
	const { dropProps, isDropTarget } = useDrop({
		ref,
		async onDrop(e) {
			let item = e.items.find((item) => item && item.kind === 'file' && (
				item.type === 'image/jpeg' ||
				item.type === 'image/png')) as FileDropItem;
			if (item) {
				let reader = new FileReader();
				reader.readAsDataURL(await item.getFile());
				reader.onload = () => {
					if (typeof reader.result === 'string') {
						updateImageBase64(reader.result);
					}
				};
				reader.onerror = (error) => console.log('Error: ', error);
			}
		}
	});
	
	return (
		<label
			{...dropProps}
			role="button"
			tabIndex={0}
			ref={ref}
			htmlFor='imageSelect'
			className={`upload-image-label drop-container droppable${isDropTarget ? ' target' : ''}`}
			id='dropcontainer'>

			<div className='upload-image-button'>
				<img src={plusIconDark} alt='upload-image-button' className='upload-button-icon' />
			</div>

			<input
				className='upload-image-input'
				id='imageSelect'
				type='file'
				accept='image/jpeg, image/png' 
				onChange={async(event: ChangeEvent<HTMLInputElement>) => {
					if (!event || !event.target || !event.target.files) {
						return;
					}

					let file = event.target.files[0];
					if (file && file.type !== 'image/jpeg' && file.type !== 'image/png') {
						return;
					}

					if (file) {
						let reader = new FileReader();
						reader.readAsDataURL(file);
						reader.onload = () => {
							if (typeof reader.result === 'string') {
								updateImageBase64(reader.result);
							}
						};
						reader.onerror = (error) => console.log('Error: ', error);
					}
				}} />
		</label>
	)
}

export default ImageInput;